import { memo } from 'react';
import { useFiles } from '../../../hooks/use-files';
import { Button, HStack } from 'app/pages/request-single-page/components-v4';
import { useResponsive } from 'app/hooks';

type DialogFooterProps = {
  hasFiles: boolean;
  uploadStatus: ReturnType<typeof useFiles>['uploadStatus'];
  onCancel: () => void;
  onCommit: () => void;
};

export const DialogFooter = memo(
  ({ hasFiles, uploadStatus, onCancel, onCommit }: DialogFooterProps) => {
    const { viewport } = useResponsive();

    const isUploading =
      uploadStatus === 'uploading' || uploadStatus === 'reserving';

    return (
      <HStack
        spacing={viewport.mobile ? 'xs' : 's'}
        justify="flex-end"
        style={{
          flexDirection: viewport.mobile ? 'column-reverse' : 'row',
        }}
      >
        <Button
          mode="neutral"
          size="l"
          style={{ width: '100%' }}
          onClick={onCancel}
        >
          Отмена
        </Button>
        <Button
          mode="accent"
          size="l"
          style={{ width: '100%' }}
          disabled={!hasFiles}
          pending={isUploading}
          onClick={onCommit}
        >
          Сохранить
        </Button>
      </HStack>
    );
  }
);
